<template>
  <div>
  
  <v-row>
    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="pa-14 ma-14">
      <h1 class="font-weight-regular display-2 green--text text--darken-2">{{item.itemData.name}}</h1>
      

      <h3 class="font-weight-regular green--text text--darken-2 mt-2">${{item.itemData.variations[0].itemVariationData.priceMoney.amount*0.01}}</h3>
      <v-btn class="mt-10 green--text text--darken-2" @click="addToCart" large outlined width="320px" tile><h5>add to cart</h5></v-btn>
      <h4 class="mt-5 font-weight-regular green--text text--lighten-2">Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Aspernatur sapiente voluptas deserunt magnam nihil iure,
        numquam rerum maxime nostrum hic animi unde consequuntur
        quod odit explicabo inventore nulla reiciendis enim.</h4> 
    </v-col>

     <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="pa-14 ma-14">
      <img class="pt-1" :src="item.itemData.description" height="400"/>
    </v-col>
  </v-row>
  </div>
</template>

<script>
// import Navbar from '../components/detailspage/Navbar.vue'
import axios from 'axios'
export default {
  components: { },

  data(){
    return {
      item:{}
    }
  },
  methods:{
    addToCart(){
      this.$store.commit("addToCart",this.item)
    }
  },
  // 54.204.50.174
  async mounted(){
    await axios.get('https://zaastry-node.herokuapp.com/items').then(res=>{
      console.log(res.data)
      let items=res.data
      console.log(this.$route.params.id)
      for(var i=0;i<items.length;i++){
        if(items[i].id==this.$route.params.id){
          console.log(items[i].id,"ho")
          this.item=items[i]
        }
      }
    })
  }

}
</script>

<style>

</style>